import { getApiURL, getSessionId } from 'utils/utils';
import axios from 'axios';
import { LOCAL_STORAGE } from 'utils/constants';

const instance = axios.create({
  // baseURL: 'http://localhost:9781',
  baseURL: getApiURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});
export const getProfile = () =>
  instance.post(`/web-app/users/get-profile`, undefined, {
    headers: {
      sessionId: getSessionId(),
    },
  });
export const login = (params) =>
  instance
    .post(`/web-app/users/login`, params)
    .then((response) =>
      localStorage.setItem('sessionId', response.data.sessionId)
    );

export const forgotPassword = (params) =>
  instance.post(`/web-app/users/forget-password`, params);
export const resetPassword = (params) =>
  instance.post(`/web-app/users/reset-password`, params);

export const register = (params) =>
  instance.post(`/web-app/users/register`, params);

export const verifyEmail = (params) =>
  instance.post(`/web-app/users/verify-email`, params);

export const askCode = (params) =>
  instance.post(`/web-app/users/ask-code`, params);

export const logout = (redirectHome) =>
  instance
    .post(`/web-app/users/logout`, undefined, {
      headers: {
        sessionId: getSessionId(),
      },
    })
    .then(() => {
      localStorage.removeItem('sessionId');
      localStorage.removeItem(LOCAL_STORAGE.CURRENT_DOMAIN_VALIDATION);
      if (redirectHome) {
        redirectHome();
      }
    })
    .catch(() => {
      localStorage.removeItem('sessionId');
      localStorage.removeItem(LOCAL_STORAGE.CURRENT_DOMAIN_VALIDATION);
      if (redirectHome) {
        redirectHome();
      }
    });

export const submitLinkedInUrl = (url) =>
  instance.post(
    `/web-app/users/submit-linkedin-url`,
    { linkedInUrl: url },
    {
      headers: {
        sessionId: getSessionId(),
      },
    }
  );

export const submitInviteCode = (inviteCode) =>
  instance.post(
    `/web-app/users/submit-invite-code`,
    { inviteCode: inviteCode },
    {
      headers: {
        sessionId: getSessionId(),
      },
    }
  );

export const sawOnboarding = () =>
  instance.post(`/web-app/users/set-has-seen-onboarding`, undefined, {
    headers: {
      sessionId: getSessionId(),
    },
  });

export const redeemPoints = (domain) =>
  instance.post(
    `/web-app/users/redeem`,
    { domain },
    {
      headers: {
        sessionId: getSessionId(),
      },
    }
  );
